import { ROLES } from 'utils/authorization';

// Tài khoản học sinh hiển thị tất cả sách theo cấp, dùng để demo
const studentsDemo = ['hocsinhcap1@gmail.com', 'hocsinhcap2@gmail.com', 'hocsinhcap3@gmail.com'];

//Tài khoản giáo viên test
const testTeachers = ['giaoviencap1@gmail.com', 'giaoviencap2@gmail.com', 'giaoviencap3@gmail.com', 'Preschool1@gmail.com'];

//tài khoản admin
const administrators = [
  'nmhaof@gmail.com',
  'nguyen.hao@ames.edu.vn',
  'tungnt@softech.vn',
  'luannt@aesgroup.edu.vn',
  'testitdn@gmail.com',
  'duongchinh.sunny@gmail.com',
  'admin@gmail.com',
  'trangnhd@phuongnam.edu.vn',
  'trinm@phuongnam.edu.vn',
];

// Tài khoản nhập liệu testBank
const testBankAccounts = ['ctv@gmail.com'];

// Học sinh lớp 1-5 demo
const permission = Array(5)
  .fill(null)
  .map((_, index) => `hocsinhlop${index + 1}@gmail.com`);

const checkAdminRole = (loggedInUser) => {
  // administrators là list các account admin nhưng role student vì dùng API của hành trang sách số
  const check = administrators.includes(loggedInUser.email.toLowerCase()) || loggedInUser.role === ROLES.ADMINISTRATOR;
  return check;
};

//Những dữ liệu câu hỏi, bài tập, thư mục được soạn bởi admin hoặc manager sẽ public cho toàn hệ thống dùng, ngược lại thì sẽ là private, ai soạn nấy dùng
const getPermissionStatusFromLoggedInUser = (loggedInUser) => {
  const status = checkAdminRole(loggedInUser) || loggedInUser.role === ROLES.MANAGER ? 'PUBLIC' : 'PRIVATE';
  return status;
};

//Kiểm tra xem người dùng có quyền update dữ liệu hay không
const checkPermissionEditData = ({ loggedInUser, createdBy, type }) => {
  //Người tạo có quyền sửa
  if (createdBy === loggedInUser?.id) {
    return true;
  }
  const isAdmin = checkAdminRole(loggedInUser);
  const isManager = loggedInUser?.role === ROLES.MANAGER;
  //Admin với manager mới được chỉnh sửa đề PUBLIC
  if (type === 'PUBLIC' && (isAdmin || isManager)) {
    return true;
  }
  //Không có quyền chỉnh sửa nếu không thuộc 2 trường hợp trên
  return false;
};

export { administrators, checkAdminRole, permission, studentsDemo, testTeachers, testBankAccounts, getPermissionStatusFromLoggedInUser, checkPermissionEditData };
